import { render, staticRenderFns } from "./adFormat.vue?vue&type=template&id=f8457118"
import script from "./adFormat.vue?vue&type=script&lang=js"
export * from "./adFormat.vue?vue&type=script&lang=js"
import style0 from "./adFormat.vue?vue&type=style&index=0&id=f8457118&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports